package com.eladfinish.bible.contest.screens.browse.tableOfContents.model

import androidx.compose.runtime.Immutable
import dev.icerock.moko.resources.desc.StringDesc

@Immutable
data class ChapterOrParashaOrSederData(
    val name: StringDesc,
    val bookIndex: Int,
    val partIndex: Int, // chapter/parasha/seder index
)
